// @flow
import BaseComponent from '../base_component/base_component'

export default class RoadshowDetails extends BaseComponent {

    initialize() {
        $( "#accordion" ).accordion({
            collapsible: true,
            event: "click",
            animate:400,
            active: 0,
            heightStyle: true,
            header: '.accordion-header',
            icons:{header:"ui-icon-caret-1-s",activeHeader:"ui-icon-caret-1-n"}
        });
        let headers = this.headers = new Map();
        $(this.component).find('.accordion-header').each(function() {
            headers.set(new Date(Date.parse($(this).text())), $(this).parent());
        });
        this.tagFilters = new Set();
    }

    functions() {
        return {
            reloadData: () => {},
            addDateFilter: (startDate: any, endDate: any) => this.setDateRange(startDate, endDate),
            removeDateFilter: () => this.setDateRange(),
            toggleTag: (value: string, category: string, checked: boolean) => this
                .toggleTag(category, value, checked)
        }
    }

    setDateRange(start: ?Date, end: ?Date) {
        if (!start || !end) {
            for(let header of this.headers.values()) {
                header.removeClass('hidden-date');
            }
            return;
        }

        for (let [date, element] of this.headers.entries()) {
            let displayed = (date >= start) && (date <= end);
            element.toggleClass('hidden-date', !displayed);
        }
    }

    toggleTag(category: string, value: string, checked: boolean) {
        // Quite a naive approach, but very flexible to changes in the .liquid.
        if (checked) {
            this.tagFilters.add(value);
        } else {
            this.tagFilters.delete(value);
        }
        this._updateTagFilters();
    }

    _updateTagFilters() {
        let filters = this.tagFilters;
        for (let section of this.headers.values()) {
            let allHidden = true;
            let skipped = false;
            section.children().last().find('tr').each(function() {
                if (!skipped) return (skipped = true);
                let matched = filters.size === 0;
                for (let filter of filters) {
                    matched = matched || $(this).text().includes(filter);
                }
                $(this).closest('table').toggleClass('hidden-tag', !matched);
                allHidden = allHidden && !matched;
            })

            section.toggleClass('hidden-tag', allHidden);
        }
    }
}